import {http} from "../config/Constantes";

export default class AcordoService {
    constructor() {}

    listVigentesByContrato(codigoBu, cnpj) {
        return http.get("/acordo/"+codigoBu+"/"+cnpj+"/vigentes")
    }

    obterPorNumeroAcordo(cnpj, numero) {
        return http.get("/acordo/"+cnpj+"/"+numero);
    }
}